import { Injectable } from '@angular/core';
import { objectVal, ref } from '@angular/fire/database';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AsyncHlp } from 'src/app/shared/helpers/async.helper';
import { EstateQrRouteData, normalizeEstateQrRouteData } from 'src/app/view/estate-view/helpers/estate-qr.helper';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { SubmitEstateQrDefectData, SubmitEstateQrDefectResult } from 'src/lib/fliko/models/http/estateQrDefect.data';
import { FireDbService } from './fireDb.service';

const PUBLIC_ESTATE_QR_ROUTE_PATH = 'publicEstateQrRoute';

@Injectable({ providedIn: 'root' })
export class PublicEstateQrService {
  private readonly commonDbRef = FireDbService.getDbRef(FireDbService.commonDbName);

  constructor(private functions: Functions) {}

  public getRouteData$(qrCodeId: string | null | undefined): Observable<EstateQrRouteData | null> {
    const trimmedQrCodeId = StrHlp.trimToNull(qrCodeId);
    if (!trimmedQrCodeId) return of(null);

    return objectVal<Record<string, unknown> | null>(
      ref(this.commonDbRef, `${PUBLIC_ESTATE_QR_ROUTE_PATH}/${trimmedQrCodeId}`)
    ).pipe(
      map((routeData) => normalizeEstateQrRouteData(routeData)),
      catchError((error) => {
        console.error('Failed to load public estate QR route data', error);
        return of(null);
      })
    );
  }

  public getRouteData(qrCodeId: string | null | undefined): Promise<EstateQrRouteData | null> {
    return AsyncHlp.onFirst(this.getRouteData$(qrCodeId)).then((routeData) => routeData ?? null);
  }

  public async submitEstateQrDefect(payload: SubmitEstateQrDefectData): Promise<SubmitEstateQrDefectResult | null> {
    const submitEstateQrDefect = httpsCallable<SubmitEstateQrDefectData, SubmitEstateQrDefectResult>(
      this.functions,
      'submitEstateQrDefect'
    );

    return (await submitEstateQrDefect(payload)).data ?? null;
  }
}
